import * as Sentry from '@sentry/browser'
import * as Integration from '@sentry/integrations'
import SentryRRWeb from '@sentry/rrweb'

const ignoreErrors = [
    /^Cancel/,
    /unknown/,
    /Non-Error/,
    /Uncaught/,
    /401/,
    /scrollHeight/,
    /getBoundingClientRect/,
    /clientWidth/
]
export default (Vue, vm) => {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DNS,
        environment: process.env.NODE_ENV,
        integrations: [
            new Integration.Vue({
                Vue,
                attachProps: true,
                logErrors: true
            }),
            new SentryRRWeb()
        ],
        ignoreErrors
    })

    vm.$watch(
        () => {
            return vm.$store.getters.userState.hash
        },
        () => {
            const user = vm.$store.getters.userState
            if (user.hash) {
                Sentry.setUser({
                    id: user.hash,
                    username: user.name,
                    email: user.email,
                    ip_address: user.ip || 'auto'
                })
            }
        }
    )

    Sentry.setTag('rrweb.active', 'yes')

    Vue.config.errorHandler = (err, v, info) => {
        Sentry.setTag('path', vm.$route.path)
        Sentry.setTag('info', info)
        Sentry.captureMessage(err.message)
        Sentry.captureException(err)

        if (process.env.NODE_ENV !== 'production') {
            console.error(err)
        }
    }
}
